<template>
  <form class="filters">
    <v-layout row>
      <v-flex>
        <v-autocomplete
          v-model="filtros.username"
          :items="view.elem.select.username.filteredList"
          :label="$t('view.commons.usuario')"
          item-text="name"
          item-value="code"
          :max-height="200"
          :disabled="view.action.submit.busy"
          hide-selected
          multiple
          clearable
          dense
          deletable-chips
          small-chips
          @input="search = ''" />
      </v-flex>

      <v-flex>
        <datePicker
          ref="datePickerDateIni"
          :key="refreshkey"
          :name="'dateIni'"
          :label="$t('view.commons.dateIni')"
          :value.sync="view.elem.dateIni"
          :dense="true"
          :disabled="view.action.submit.busy"
          @changeDate="changeDate" />
      </v-flex>

      <v-flex>
        <datePicker
          ref="datePickerDateEnd"
          :key="refreshkey"
          :name="'dateEnd'"
          :label="$t('view.commons.dateEnd')"
          :value.sync="view.elem.dateEnd"
          :disabled="view.action.submit.busy"
          :min="view.elem.dateIni"
          :dense="true"
          :enable-today="new Date(view.elem.dateIni) <= new Date()"
          @changeDate="changeDate" />
      </v-flex>

      <v-flex md2>
        <v-btn fab x-small color="primary" elevation="0" class="btn_tippy ml-4" :title="$t('view.commons.clear')" :loading="view.action.submit.busy" @click="clear">
          <v-icon x-small>fas fa-eraser</v-icon>
        </v-btn>
        <v-btn fab x-small elevation="0" color="primary" class="btn_tippy ml-4" :title="$t('view.commons.search')" :loading="view.action.submit.busy" @click="filter">
          <v-icon x-small>fas fa-search</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
import CombosAPI from "@/services/catalogos"; /** *******************************/
import DatePicker from "@/components/forms/DatePicker"; /** *******************************/
import tippy from "tippy.js";
import { setToday } from "@/helpers/date-methods";

export default {
  name: "FiltersModule"
  , components: { DatePicker }
  , props: {
    select: {
      default: null
      , type: Object
    }
  }
  , data() {
    return {
      refreshkey: 0
      , view: {
        action: { submit: { busy: false } }
        , elem: {
          menu: { visible: false }
          , select: {
            username: {
              completeList: []
              , filteredList: []
            }
          }
          , dateIni: setToday()
          , dateEnd: setToday()
        }
      }
      , filtros: {
        username: []
        , fecha: []
      }
    };
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , created() {
    this.$nextTick(() => this.loadSelectsData());
  }
  , methods: {
    filter() {
      if (this.view.elem.dateIni && this.view.elem.dateEnd) {
        this.filtros.fecha = [];
        this.filtros.fecha.push(`(${this.view.elem.dateIni}|${this.view.elem.dateEnd})`);
      }
      this.$emit("filter", this.filtros);
    }
    , clear() {
      this.filtros = Object.fromEntries(Object.keys(this.filtros).map((key) => [key, []]));
      this.view.elem.dateIni = "";
      this.view.elem.dateEnd = "";
      this.refreshkey += 1;
      this.$emit("filter", this.filtros);
    }
    , changeDate(field, value) {
      this.view.elem[field] = value;
      this.changeDateIni();
    }
    , changeDateIni() {
      if (new Date(this.view.elem.dateIni) > new Date(this.view.elem.dateEnd)) {
        this.view.elem.dateEnd = this.view.elem.dateIni;
        this.refreshkey += 1;
      }
    }
    , async loadSelectsData() {
      const { data: { results: { combo: responseUsernameList } } } = await CombosAPI.get({ option: "usuariosActive" });
      this.view.elem.select.username.filteredList = responseUsernameList ? responseUsernameList.filter((value) => value.status) : [];
      this.view.elem.select.username.completeList = responseUsernameList || [];
      this.refreshkey += 1;
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
  }
};
</script>

<style scoped>
.filter_button {
  margin-top: 15px;
  width: 35px !important;
  height: 35px !important;
  font-size: 10px !important;
}
.filter_button .v-icon {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bitacoras/bitacora/Filters.vue